/** @format */
/**
 * @description the interface of user authentication entity
 * @export
 * @interface IAppState
 */

import { EnumValueDataType } from "utils";

export interface IInforForgot {
  email: string;
  confirmCode: string;
  verifyCode: string;
}
export interface IAppState {
  loading: boolean;
  language: string;
  error: string | null;
  captcha?: string;
  showCaptcha?: boolean;
  isAuth: boolean;
  inforForgot: IInforForgot;
  authToken?: string;
}
export interface INofifyState {
  message: string;
  type: "success" | "info" | "warning" | "error";
  options: {
    position: {
      vertical: "top" | "bottom";
      horizontal: "left" | "center" | "right";
    };
    autoHideDuration: number;
    useI18n: boolean;
  };
}

export type IValueType = keyof typeof EnumValueDataType;

export enum ELanguage {
  KO = "ko",
  EN = "en",
}
export interface IKeyAuth {
  accessToken: string;
  refreshToken?: string;
  userId?: string;
  updateParent?: boolean;
}

export type IThemeColor = "main" | "light" | "dark";
export type IThemeMode = "default";

export type TPagination = {
  limit: number;
  page: number;
  total: number;
  totalPage: number;
};

export type TResponse<T> = {
  data: T;
  pagination?: TPagination;
  statusCode: number;
  message: string;
};

export type TParams = {
  page: number;
  limit: number;
  valueSearch?: string;
  [x: string]: string | number | undefined;
};

export type TWarrantyLookupParams = {
  page: number;
  limit: number;
  type?: string;
  keyword?: string;
};

export enum TypeServiceName {
  GEN_ME = "GEN_ME",
  OUTFIT = "OUTFIT",
  HAIR_SWAP = "HAIR_SWAP",
  BODY_SHAPE = "BODY_SHAPE",
  ANIMATE = "ANIMATION_ANYONE",
}

export enum TypeYourBody {
  YOUR_BODY = "YOUR_BODY",
  BODY_SHAPE = "BODY_SHAPE",
}
export const arrTab = [
  {
    title: "Style Fit",
    value: TypeServiceName.OUTFIT,
  },
  {
    title: "Gen Me",
    value: TypeServiceName.GEN_ME,
  },
  {
    title: "Style Hair",
    value: TypeServiceName.HAIR_SWAP,
  },
  {
    title: "Animate Anyone",
    value: TypeServiceName.ANIMATE,
  },
];

export enum StatusRequest {
  NEW = "NEW",
  STARTED = "STARTED",
  PROCESSING = "PROCESSING",
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
}

export enum ENotification {
  MAINTAIN = "MAINTAIN",
  DEFAULT = "",
}
export type TLine = {
  valueSize: number;
  tool: string;
  points: number[];
};

export interface ThemeOption {
  colorSchemes?: {
    light?: {
      bgMain?: string;
      borderGray?: string;
      textTitle?: string;
      colorIcon?: string;
      bgHover?: string;
      bgModal?: string;
      bgProcess?: string;
      bgPhoto?: string;
      bgPhotoActive?: string;
      bgSecondary?: string;
      bgTable?: string;
      border?: string;
      bgInput?: string;
      textSearch?: string;

      primary?: string;
      secondary?: string;
      warning?: string;
      success?: string;
      info?: string;
      error?: string;
      grey?: string;
      mainBlack?: string;
      white?: string;
      textMain?: string;
      textGray?: string;
      borderColor?: string;
      bgButton?: string;
      textSecondary?: string;
      bgLinear?: string;
      bgLinear_2?: string;
      bgLinear_3?: string;
    };
    dark?: {
      bgMain?: string;
      borderGray?: string;
      textTitle?: string;
      colorIcon?: string;
      bgHover?: string;
      bgModal?: string;
      bgProcess?: string;
      bgPhoto?: string;
      bgPhotoActive?: string;
      bgSecondary?: string;
      bgTable?: string;
      border?: string;
      bgInput?: string;
      textSearch?: string;

      primary?: string;
      secondary?: string;
      warning?: string;
      success?: string;
      info?: string;
      error?: string;
      grey?: string;
      mainBlack?: string;
      white?: string;
      textMain?: string;
      textGray?: string;
      borderColor?: string;
      bgButton?: string;
      textSecondary?: string;
      bgLinear?: string;
      bgLinear_2?: string;
      bgLinear_3?: string;
    };
  };
}

export interface TypeIndicate {
  id: number;
  order_no: number;
  name: string;
}

export interface PaginationBarProps {
  page: number;
  totalPages: number;
  pageSize: number;
  pageSizeOptions: number[];
  onPrev: () => void;
  onNext: () => void;
  onGoToPage: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}
